import{LOCATION_ADDRESS_FIELDS as n}from"./address-fields.js";const a=`\nnodes {\n  available\n  pickUpTime\n  quantityAvailable\n  location {\n    id\n    name\n    address {\n      ${n}\n    }\n  }\n}\n`;export{a as STOREFRONT_STORE_AVAILABILITY_FRAGMENT};
//# sourceMappingURL=store-availability.js.map
